// TODO: esto puede venir de bit
import {
  enviromentKey,
  DEV,
  PRODUCT_TYPE_FUSION_MI_MOVISTAR,
  PACK_KEYS,
  MI_MOVISTAR_WITH_NETFLIX,
  NETFLIX_BUNDLE_ID,
} from "@/constants/constants";
import { ENV_NAME } from "@gcloud-npm/utils.enums.environment";
import isFrontApp from "@gcloud-npm/utils.common.is-front-app";
import queryString from "query-string";
import {
  getProductNameOfferingByType,
  normalizeExplanatoryText,
} from "./dataHandlers/CatalogueDataHandler";
import { TEXT_TYPES_CODES } from "@/constants/catalogue";
// TODO: esto puede venir de bit
export const howAppIsRunning = () => {
  const { NODE_ENV } = process.env;
  return NODE_ENV;
};

// TODO: teneis una accion en el redux de main para estos envios
export const sendMessageHeader = (id, objNotification) => {
  // window.nookInfoExchange.sendMessage(id, objNotification);
};

export const callGetegService = (xcol) => {
  try {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", "https://webservices.telefonica.es/ws/i01/avacol/geteg");
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.setRequestHeader("Accept", "application/json; charset=utf-8");
    xhr.withCredentials = true;
    xhr.onload = () => {
      if (xhr.status === 200 && xhr.responseText !== xcol) {
      } else if (xhr.status !== 200) {
        // console.log(`Request failed.  Returned status of ${xhr.status}`);
      }
    };
    xhr.send(`XCOL=${xcol}`);
  } catch (err) {
    // console.log(err);
  }
};

// TODO: esto puede venir de bit
export const setCookie = (cName, value, exdays, domain = "") => {
  const exdate = new Date();
  exdate.setDate(exdate.getDate() + exdays);

  let cValue = null;
  if (!domain) {
    cValue =
      escape(value) +
      (exdays === null ? "" : `;expires=${exdate.toUTCString()};path=/`);
  } else {
    cValue =
      escape(value) +
      (exdays === null
        ? `;expires=;domain=${domain};path=/`
        : `;expires=${exdate.toUTCString()};domain=${domain};path=/`);
  }

  document.cookie = `${cName}=${cValue}`;
};

export const getUrl = (key, library) => {
  let res = "";
  const item = library.find((element) => element.loader === key);
  if (item && key) {
    const urlRes = `${process.env.NEXT_PUBLIC_PROJECT_BASE_PATH}${item.pathName}`;
    const tokkens = urlRes.split("/");
    tokkens.forEach((tokken) => {
      const cnd = tokken.indexOf(":") > -1;
      if (!cnd && tokken) {
        res = `${res}/${tokken}`;
      }
    });
  } else {
    console.warn(`There is no url for: ${key}`);
  }
  return res;
};

export const push2DataLayerError = (
  event = "",
  APeventAction = "",
  APeventLabel = ""
) => {
  if (howAppIsRunning() !== DEV) {
    const { dataLayer } = window;
    const numberOfEvents = dataLayer.length;
    let eventCounter = 0;
    let pushConfirmation = true;
    for (
      let dlindex = numberOfEvents - 1;
      dlindex >= 0 && eventCounter < 5;
      dlindex -= 1
    ) {
      const currentEvent = dataLayer[dlindex];
      if (APeventAction === currentEvent.APeventAction) {
        pushConfirmation = false;
        break;
      }
      eventCounter += 1;
    }

    // only push one time
    if (pushConfirmation) {
      //TODO: usar metodos de bit
      // dataLayer.push({
      //   event,
      //   APeventAction,
      //   APeventLabel,
      // });
    }
  }
};

export function checkMocks(MOCK_INFO) {
  if (
    enviromentKey !== ENV_NAME.PROD &&
    isFrontApp &&
    sessionStorage &&
    sessionStorage.getItem(MOCK_INFO)
  ) {
    return JSON.parse(sessionStorage.getItem(MOCK_INFO));
  }
  return null;
}

export const slideDown = (id, finalheight, duration) => {
  const element = document.getElementById(id);
  const s = element.style;
  s.height = "0px";
  let y = 0;
  let currentFrame = 0;
  const framerate = 30;
  const oneSecond = 1000;
  const interval = (oneSecond * duration) / framerate;
  const totalframes = (oneSecond * duration) / interval;
  const heightincrement = finalheight / totalframes;
  const tween = () => {
    y += heightincrement;
    if (currentFrame < totalframes) {
      s.height = `${y}px`;
      currentFrame += 1;
      setTimeout(tween, interval);
    } else {
      s.height = "auto";
    }
  };
  tween();
};

export const slideUp = (id, finalheight, duration) => {
  const element = document.getElementById(id);
  const s = element.style;
  s.height = `${element.offsetHeight}px`;
  let y = element.offsetHeight; // 132
  const currentFrame = 0;
  const framerate = 30;
  const oneSecond = 1000;
  const interval = (oneSecond * duration) / framerate; // 17
  const totalframes = (oneSecond * duration) / interval; // 30
  const heightincrement = element.offsetHeight / totalframes; // 4.40000547
  // const heightincrementOneDecimal = parseInt(heightincrement.toFixed(2), 10)
  const tween = () => {
    y -= heightincrement;
    if (y < 0) {
      y = 0;
    }
    s.height = `${y}px`;
    /* if (currentFrame <= totalFramesGood) {
      currentFrame += 1;
      setTimeout(tween, interval);
    } */
    if (y > 0) {
      // currentFrame += 1;
      setTimeout(tween, interval);
    }
  };
  tween();
};
export const sumArray = (arr) => {
  if (arr && arr.length > 0) {
    return arr.reduce((sum, x) => sum + x);
  }
  return null;
};

export const shuffle = (arr) => {
  const res = [...arr];
  const aux = [...arr];
  let j;
  let i = res.length;
  let ind = 0;
  for (i = arr.length; i > 0; i -= 1) {
    //  ;
    j = Math.floor(Math.random() * i);
    // console.log('índice: ', ind, 'secuencia: ', aux[j].idSecuence)
    res[ind] = aux[j];
    aux.splice(j, 1);
    ind += 1;
  }
  return res;
};

/* Get all params on the current url like ?prod=producto&test="ok" */
export const getUrlParams = () => {
  let params = null;
  try {
    // detecting if we have # has router
    const hashInfo = !!window.location.hash;
    const searchParams = !!window.location.search;
    const hashRouterParasm =
      hashInfo && !searchParams && window.location.hash.indexOf("?") > -1;
    if (hashRouterParasm) {
      const beginPosition = window.location.hash.indexOf("?");
      const string2Analise = window.location.hash.substr(beginPosition);
      params = queryString.parse(string2Analise);
    } else {
      params = queryString.parse(window.location.search);
    }
  } catch (err) {
    errorLog("Error on [getUrlParams] in jsUtils file");
  }
  return params;
};

export const removeElementsByClass = (className) => {
  const elements = document.getElementsByClassName(className);
  while (elements.length > 0) {
    elements[0].parentNode.removeChild(elements[0]);
  }
};

// From string '666777888' -> '666 77 78 88'
export const formatMobileNumber = (mobileNumber) => {
  return mobileNumber.replace(/^(.{3})(.{2})(.{2})(.{2})(.*)$/, "$1 $2 $3 $4");
};

/**
 * La función recoge la url de la página para obtener el alias
 * que se usa en la llamada de orion
 * @param {String} url
 * @returns devuelve el alias para realizar la búsqueda de orion
 */
export const getAliasOrionFromUlr = (url) => {
  let alias = url.split("/area-cliente/");
  alias = alias[1] && alias[1].replace(/\/$/, "");
  return alias.replace(/\//g, "-");
};

/**
 * La función recoge la url de la página para obtener el alias
 * que se usa en la llamada de orion
 * @param {String} url
 * @returns devuelve el alias para realizar la búsqueda de orion
 */
export const getPhoneTypeFromUlr = (url) => {
  let type = null;
  const parts = url.split("/area-cliente/gestiones/");
  type = parts[1] && parts[1].replace("linea-", "");
  if(type){
    return type.includes("fija")? "fijo" : type;
  }
  return null;
};

export const getProductOfferingsByProductId = ({
  hiredProductsList,
  productId,
}) => {
  if (
    hiredProductsList &&
    Array.isArray(hiredProductsList) &&
    hiredProductsList.length > 0
  ) {
    const filterProduct = hiredProductsList.filter(
      (product) => product?.productId == productId
    );
    return filterProduct[0] && filterProduct[0]?.productOfferingTypes;
  }
  return null;
};

export const getIdPoByProductId = ({
  hiredProductsList,
  productId,
  normalizePoIdForOrion = false,
}) => {
  if (
    hiredProductsList &&
    Array.isArray(hiredProductsList) &&
    hiredProductsList.length > 0
  ) {
    let poId = null;
    const filterProduct = hiredProductsList.find(
      (product) => product?.productId == productId
    );
    if (
      filterProduct?.poId === MI_MOVISTAR_WITH_NETFLIX &&
      normalizePoIdForOrion
    ) {
      const netflixProduct = hiredProductsList.find(
        (product) => product?.bundleId == NETFLIX_BUNDLE_ID
      );
      if (netflixProduct?.characteristics?.[0]?.valueId) {
        poId = `${filterProduct.poId}_${netflixProduct.bundleId}_${netflixProduct.characteristics[0].valueId}`;
      } else {
        poId = filterProduct?.poId;
      }
    } else {
      poId = filterProduct?.poId;
    }

    return poId;
  }
  return null;
};

export const getProductByProductId = ({ hiredProductsList, productId }) => {
  if (
    hiredProductsList &&
    Array.isArray(hiredProductsList) &&
    hiredProductsList.length > 0
  ) {
    const filterProduct = hiredProductsList.filter(
      (product) => product?.productId == productId
    );
    return filterProduct[0];
  }
  return null;
};

const checkIfOrionDataIsValid = (currentOrionProduct) => {
  if (
    currentOrionProduct &&
    currentOrionProduct?.title &&
    Array.isArray(currentOrionProduct?.characteristics) &&
    currentOrionProduct?.characteristics.length > 0
  ) {
    return true;
  }
  return false;
};

export const getTextOrionOrCatalogue = ({
  orionProduct,
  catalogueProductOffering,
  hiredProductsList,
  productId,
}) => {
  const idPO = getIdPoByProductId({ hiredProductsList, productId });
  const currentProduct = Array.isArray(orionProduct) && orionProduct.find((product) => product.poId === idPO);
  if (checkIfOrionDataIsValid(currentProduct)) {
    const orionLiterals = [];
    if (currentProduct?.characteristics && Array.isArray(currentProduct?.characteristics) && currentProduct?.characteristics.length > 0) {
      currentProduct.characteristics.map((text) => {
        orionLiterals.push(text?.title);
      });
    }
    return {
      title: currentProduct?.title,
      literals: orionLiterals,
    };
  } else if (catalogueProductOffering) {
    const title = getProductNameOfferingByType({
      catalogueProductOffering,
      textType: TEXT_TYPES_CODES.ORDINARY,
      poId: idPO,
    });
    const catalogueText = getProductNameOfferingByType({
      catalogueProductOffering,
      textType: TEXT_TYPES_CODES.EXPLANATORY,
      poId: idPO,
    });
    if (catalogueText && catalogueText[0] && catalogueText[0].text) {
      // const normalizeCatalogueText = normalizeExplanatoryText({
      //   text: catalogueText[0].text,
      // });
      return {
        title: title && title[0] && title[0].text,
        literals: catalogueText[0].text,
      };
    }
  } else {
    return null;
  }
};

export const idPreserveBasePath = ({ url }) => {
  return (url &&
    (url.includes("cliente/areaprivada/#/") ||
      url.includes("/particulares"))) ||
    url.includes("movistar.es")
    ? false
    : true;
};

export const getModuleByAliasOrion = ({ orionInfo, alias, aliasModule }) => {
  if (orionInfo && orionInfo[alias]?.normalizeInfo) {
    const module = orionInfo[alias]?.normalizeInfo.filter(
      (mod) => mod?.alias === aliasModule
    );
    return module[0];
  }
};

export const removePhoneNumbers = (str) => {
  // Regular expression to match 9-digit phone numbers
  const regex = /\b\d{9}\b/g;

  // Replace all occurrences of 9-digit numbers with an empty string
  return str?.replace(regex, "");
};

export const getTextPackText = ({
  catalogueProductOffering,
  hiredProductsList,
  productId,
}) => {
  if (catalogueProductOffering) {
    const idPO = getIdPoByProductId({ hiredProductsList, productId });
    const title = getProductNameOfferingByType({
      catalogueProductOffering,
      textType: TEXT_TYPES_CODES.ORDINARY,
      poId: idPO,
    });
    const catalogueText = getProductNameOfferingByType({
      catalogueProductOffering,
      textType: TEXT_TYPES_CODES.EXPLANATORY,
      poId: idPO,
    });
    if (catalogueText && catalogueText[0] && catalogueText[0].completeText) {
      // const normalizeCatalogueText = normalizeExplanatoryText({
      //   text: catalogueText[0].text,
      // });
      let hasTitles = catalogueText[0].completeText.filter(
        (item) => item.title !== null
      );
      const sortCatalogueText = catalogueText[0].completeText.sort(
        compareTitle(PACK_KEYS)
      );
      if (hasTitles.length > 0) {
        const half = Math.ceil(sortCatalogueText.length / 2);
        return {
          title: title && title[0] && title[0].text,
          literalsColumn1: sortCatalogueText.slice(0, half),
          literalsColumn2: sortCatalogueText.slice(half),
        };
      } else {
        return {
          title: title && title[0] && title[0].text,
          literalsColumn1: sortCatalogueText,
        };
      }
    }
  } else {
    return null;
  }
};

export const sliceStringUntilIndexorWord = (products, index) => {
  let lettersSum = 0;
  let validWords = 0;
  let flag = false;

  products.forEach(({ name }) => {
    if (lettersSum < index && !flag) {
      lettersSum = lettersSum + name.length;
      validWords = validWords + 1;
    }
    if (lettersSum > index && !flag) {
      validWords = validWords - 1;
      flag = true;
    }
  });

  if (validWords === 0) {
    validWords++;
  }

  return validWords;
};

export const formatRenttoRentDate = ({ dateString }) => {
  const isoDate = new Date(dateString);

  const day = isoDate.getDate().toString().padStart(2, "0");
  const month = (isoDate.getMonth() + 1).toString().padStart(2, "0"); // Adding 1 because months in JS are zero-based
  const year = isoDate.getFullYear();

  return `${day}/${month}/${year}`;
};

export const getPreviousYear = () => {
  let today = new Date();
  today.setFullYear(today.getFullYear() - 1);
  let previousYear = today.getFullYear();

  return previousYear;
};

export const isProductTypeFusionMiMovistar = ({
  hiredProductsList,
  productId,
}) => {
  if (productId && hiredProductsList) {
    const product = hiredProductsList.filter(
      (item) =>
        item.productId === productId &&
        item.productType === PRODUCT_TYPE_FUSION_MI_MOVISTAR
    );
    if (product && product.length > 0) {
      return true;
    }
  }
  return false;
};

export const compareTitle = (keywordMap) => (a, b) => {
  const keywordA = Object.keys(keywordMap).find(
    (keyword) => a && a.title && a.title.toLowerCase().includes(keyword)
  );
  const keywordB = Object.keys(keywordMap).find(
    (keyword) => b && b.title && b.title.toLowerCase().includes(keyword)
  );

  if (keywordA && keywordB) {
    return keywordMap[keywordA] - keywordMap[keywordB];
  } else if (keywordA) {
    return -1;
  } else if (keywordB) {
    return 1;
  } else {
    return 0;
  }
};

export const formatIsoDate = (dateString) => {
  const isoDate = new Date(dateString);
  const day = String(isoDate.getDate()).padStart(2, '0');
  const month = String(isoDate.getMonth() + 1).padStart(2, '0'); // Adding 1 because months in JS are zero-based
  const year = isoDate.getFullYear();
  return `${day}/${month}/${year}`;
};

export const changePointByComma = (text) => {
  return text?.toString().replace(/\./g, ',');
}

export const changeDateFormatIsoDateHour = (dateISO) => {
  const date = new Date(dateISO);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${day}/${month}/${year} · ${hours}:${minutes} h`;
}
